import { HttpErrorResponse } from '@angular/common/http';
import { ProductListExportToEmailBody } from '@epicuro-next/data/engagement/engagement-models';
import { createAction, props } from '@ngrx/store';

export const exportProductListToEmail = createAction(
  '[ProductList] Export list to email',
  props<{
    productListId: string;
    emailData: ProductListExportToEmailBody;
    showGetInTouchButton: boolean;
  }>(),
);

export const exportListToEmailSuccess = createAction(
  '[ProductList] Export list to email success',
  props<{ productListId: string; emailData: ProductListExportToEmailBody }>(),
);

export const exportListToEmailFail = createAction(
  '[ProductList] Export list to email failed',
);

export const exportProductListToPdf = createAction(
  '[ProductList] Export list to pdf',
  props<{ productListId: string }>(),
);

export const exportProductListToPdfSuccess = createAction(
  '[ProductList] Export list to pdf success',
);

export const downloadProductListPdf = createAction(
  '[ProductList] Download list to pdf',
  props<{ listName: string; data: Blob }>(),
);

export const downloadProductListPdfSuccess = createAction(
  '[ProductList] Download list to pdf success',
);

export const downloadProductListPdfFail = createAction(
  '[ProductList] Download list to pdf fail',
);

export const exportProductListToPdfFail = createAction(
  '[ProductList] Export list to pdf failed',
  props<{ error?: HttpErrorResponse }>(),
);

export const exportProductListToSheet = createAction(
  '[ProductList] Export list to excel sheet',
);

export const exportProductListToSheetFailure = createAction(
  '[ProductList] Export list to sheet failed',
  props<{ error?: HttpErrorResponse }>(),
);

export const exportProductListImages = createAction(
  '[ProductList] Export list images',
);

export const exportProductListImagesFailure = createAction(
  '[ProductList] Export list images failed',
  props<{ error?: HttpErrorResponse }>(),
);

export const downloadProductList = createAction(
  '[ProductList] Download list',
  props<{ data: Blob; fileName: { name: string; extension: string } }>(),
);

export const downloadProductListSuccess = createAction(
  '[ProductList] Download list success',
);
